import { Injectable } from '@angular/core';

import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ReportesService {
  // * CONSTANTES
  apiReportesUrl = '/api/reportes';
  downloadReporte = '/download-reporte';
  reporteFecha = '/reporte-fecha';
  reporteFechaDetalle = '/reporte-fecha-detalle';
  reporteProducto = '/reporte-producto';
  reporteFactura = '/reporte-factura';

  constructor(private http: HttpClient) {}


  // ! DESCARGAR REPORTE
  public downloadReporteFecha(): any {
    return this.http
      .get(this.apiReportesUrl + this.downloadReporte, { responseType: 'blob' })
      .pipe(
        catchError((err) => {
          console.log('Error: ', err);
          return throwError(err);
        })
      );
  }

// ! REPORTE POR FACTURA
public generarReporteFactura(fechaI, fechaF, extRepo): Observable<any> {
  return this.http.post<any>(this.apiReportesUrl + this.reporteFactura, {
    fechaInicio: fechaI,
    fechaFin: fechaF,
    extReporte: extRepo,
  });
}

  // ! REPORTE POR FECHA
  public generarReporteFecha(fechaI, fechaF, extRepo): Observable<any> {
    return this.http.post<any>(this.apiReportesUrl + this.reporteFecha, {
      fechaInicio: fechaI,
      fechaFin: fechaF,
      extReporte: extRepo,
    });
  }

  // ! REPORTE POR FECHA DETALLADO
  generarReporteFechaDetalle = (fechaI, fechaF, extRepo): Observable<any> => {
    return this.http.post<any>(this.apiReportesUrl + this.reporteFechaDetalle, {
      fechaInicio: fechaI,
      fechaFin: fechaF,
      extReporte: extRepo,
    });
  };

  // ! REPORTE POR PRODUCTO
  generarReporteProducto = (fechaI, fechaF, extRepo): Observable<any> => {
    return this.http.post<any>(this.apiReportesUrl + this.reporteProducto, {
      fechaInicio: fechaI,
      fechaFin: fechaF,
      extReporte: extRepo,
    });
  };
}
